import React from 'react';
import SingleSpaRegisterMfe from './SingleSpaRegisterMfe';

const SingleSpaMfeContainer = ({ 
  packageName, 
  routePrefix, 
  containerId, 
  errorContainerId,
  location,
  RenderHeader,
  useFeatureFlag
}) => {

  // Always render containers first, then conditional content
  return (
    <>
      <SingleSpaRegisterMfe
        packageName={packageName}
        routePrefix={routePrefix}
        containerId={containerId}
        errorContainerId={errorContainerId}
        location={location}
        RenderHeader={RenderHeader}
        useFeatureFlag={useFeatureFlag}
      />
      <div id={errorContainerId} role="alert" aria-live="polite" data-mfe-app-name={packageName}></div>
    </>
  );
};

export default SingleSpaMfeContainer;